import Vue from 'vue'

export const EB = new Vue()



// WEBPACK FOOTER //
// ./src/addon/bus.js